import { createAction, props } from '@ngrx/store';
import { CalendarEventDto } from '@shared/dto';

// Load — operator-wide events in a date range (ISO strings). Lean `view=calendar`
// projection: the slice carries the flat CalendarEventDto, never the full graph.
export const readEvents = createAction('@app/event/read', props<{ start: string; end: string }>());
export const readEventsSuccess = createAction('@app/event/read/success', props<{ data: CalendarEventDto[] }>());
export const readEventsFailure = createAction('@app/event/read/failure', props<{ error: any }>());

// Load — the top-bar's day agenda. Deliberately a SEPARATE slot from `readEvents`:
// both surfaces are on screen at once (the top bar lives in the layout shell) but ask
// for different ranges — a day vs the dashboard's whole month — and a single slot would
// have them overwrite each other's results.
export const readAgenda = createAction('@app/event/agenda/read', props<{ start: string; end: string }>());
export const readAgendaSuccess = createAction('@app/event/agenda/read/success', props<{ data: CalendarEventDto[] }>());
export const readAgendaFailure = createAction('@app/event/agenda/read/failure', props<{ error: any }>());
